<script setup lang="ts">
const props = defineProps<{
  label: string;
}>();
</script>
<template>
  <span
    class="bg-primary-50 text-primary-500 rounded-full px-2 py-1 text-xs font-semibold"
    >{{ props.label }}</span
  >
</template>
